<template>
    <v-card style="padding: 0 40px;">
        <v-card-title class="d-flex justify-center">
            <div>
                <h1 class="m-0" style="color: #5ae6ff; font-size: 25px; font-weight: 700;">Investment Detail</h1>
                <p class="m-0">DEAL {{ company.id }} - COMPANY {{ company.company.company_name }}</p>
            </div>
            <div class="close-icon" style="cursor: pointer; position: absolute; right: 20px; top: 20px;" @click="closeModal">
                X
            </div>
        </v-card-title>

        <v-card-text style="height: 800px;" class="scrollbar" id="scrollbar">
            <div class="text-center">
                <div class="mt-3">
                    <img
                        :src="baseUrl + company?.company?.logo"
                        alt="logo"
                        style="width: 60px; height: 60px;"
                        @error="handleImageError"
                    />
                </div>
            </div>

            <div class="text-left mt-5">
                <p class="label">
                    <b>My Investment{{ investmentLength > 1 ? "s" : "" }}</b>
                </p>
                <div>
                    <div class="row">
                        <div class="col-12 col-md-6 py-0" v-if="investmentLength > 1">
                            <p class="m-0">Investments Period</p>
                            <div class="row">
                                <div class="col-12 col-md-6 pr-0 pr-md-1">
                                    <v-text-field
                                        type="text"
                                        label="Start Date"
                                        outlined
                                        dense
                                        disabled
                                        :value="formatDate(firstInvestmentDate, userCountry == 'United States')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 pl-0 pl-md-1">
                                    <v-text-field
                                        type="text"
                                        label="End Date"
                                        outlined
                                        dense
                                        disabled
                                        :value="formatDate(lastInvestmentDate, userCountry == 'United States')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 my-0 py-0" v-else>
                            <p class="m-0">Date of the deal</p>
                            <v-text-field
                                type="text"
                                disabled
                                placeholder="USD ------"
                                outlined
                                dense
                                :value="formatDate(lastInvestmentDate, userCountry == 'United States')"
                            />
                        </div>

                        <div class="col-12 col-md-3 m-0 py-0 pr-4 pr-sm-0">
                            <p class="m-0">Amount of the investment</p>
                            <v-text-field
                                prefix="USD"
                                placeholder="USD"
                                outlined
                                dense
                                disabled
                                :value="formatToString(totalInvestmentsAmount || investment?.investment_amount)"
                                class="text-right-input"
                            />
                        </div>
                    </div>
                </div>

                <div class="text-left mt-5">
                    <div class="m-0 p-0">
                        <table class="investment-table mb-3">
                            <thead>
                                <tr class="first-header">
                                    <th colspan="3" id="title" style="font-size: 16px;">History - Raised Funds</th>
                                </tr>
                                <tr class="web-header">
                                    <th id="date">Date of Investment</th>
                                    <th id="investor">Investor</th>
                                    <th class="text-right" id="amount">{{ investmentLength > 1 ? "Amount of my total Investment" : "Amount of the Investment" }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="investment in investments.investments" :key="investment.id">
                                    <td data-label="Date">{{ formatDate(investment.date_of_investment, userCountry == 'United States') }}</td>
                                    <td data-label="Investor">{{ investment.user.name}}</td>
                                    <td data-label="Amount" class="text-right">USD {{ formatToString(investment.investmentAmount) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" class="total-amount hide-on-mobile">Total of raised funds</td>
                                    <td data-label="Total of raised funds" class="text-right">USD {{ formatToString(totalInvestmentsAmount) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <div class="text-left mt-5 p-0 m-0">
                <p class="label col-12 m-0 p-0">
                    <b>Initial Funding Needs of the company</b>
                </p>
                <div class="col-12 col-md-6 m-0 p-0 mt-5">
                    <v-text-field
                        prefix="USD"
                        placeholder="USD"
                        outlined
                        dense
                        disabled
                        :value="company.needs && formatToString(company.needs.raising)"
                        class="text-right-input"
                    />
                </div>
            </div>

            <div class="text-left">
                <p class="label col-12 m-0 p-0">
                    <b>Updated Funding Needs of the company</b>
                </p>
                <div class="col-12 col-md-6 m-0 p-0 mt-5">
                    <v-text-field
                        prefix="USD"
                        placeholder="USD"
                        outlined
                        dense
                        disabled
                        :value="company.needs && formatToString(company.needs.raising - totalInvestmentsAmount)"
                        class="text-right-input"
                    />
                </div>
            </div>
        </v-card-text>
        <br/>
        <br/>
    </v-card>
</template>
<script>
    import Deal from "@/store/services/deal/deal.service";
    import { myMixins } from "@/mixins/mixins";
    import Profile from "@/store/services/profile-service";

    export default {
        mixins: [myMixins],
        props: {
            closeModal: Function,
            company: Object,
            investment: Object,
        },
        // if company changes call getDealInvestments
        watch: {
            company () {
                this.getInvestment(this.company.company.id)
            },
        },
        
        data() {
            return {
                investments: [],
                totalInvestmentsAmount: 0,
                baseUrl: "",

                // company: null,
                resume: null,
                fund_raising: null,
                personal: null,
                me: null,
                confirmAmount: null,
                loader: false,
                raisingAmount: null,
                updatedFundingNeeds: null,
                date_investment: null,
                userCountry: null,
                investmentLength: 0,
                firstInvestmentDate: null,
                lastInvestmentDate: null,
            }
        },
        methods: {
            getInvestment (companyId) {
                this.totalInvestmentsAmount = 0;
                Deal.getDealInvestments(companyId).then((res) => {
                    if (res.status == 200) {
                        this.investments = res.data;
                        let investmentDates = this.investments.investments.map(investment => investment.date_of_investment).sort();
                        this.firstInvestmentDate = investmentDates[0] || null;
                        this.lastInvestmentDate = investmentDates[investmentDates.length - 1] || null;
                        this.investmentLength = this.investments.investments.length
                        this.totalInvestmentsAmount = this.investments.investments.reduce((sum, investment) => sum + investment.investmentAmount, 0);
                    }
                }).catch((err) => {
                    this.investments = [];
                });
            }
        },
        mounted() {
            this.baseUrl = window.location.protocol + '//' + window.location.host + '/storage/';
            this.getInvestment(this.company.company.id)
            Profile.myDetails().then((res) => { this.userCountry = res.data.city })
        }
    }
</script>


<style>
    .text-right-input input {
        text-align: right;
        padding-right: 10px; /* Adjust as necessary */
    }
    /* Basic table styling */
    .investment-table {
        width: 100%;
        max-width: 800px;
        border-collapse: collapse;
        border: none !important;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    
    .investment-table th, .investment-table td {
        border: 1px solid #d4d4d4;
        padding: 10px;
        text-align: left;
    }
    .investment-table .title th {
        background-color: #8DC63F;
        color: #050505;
        text-align: center;
    }


    .investment-table thead th {
        font-size: 14px;
        padding: 12px;
    }

    .investment-table tbody tr:nth-child(odd) {
        background-color: #f9f9f9;
    }

    .investment-table tfoot td {
        font-weight: bold;
        background-color: #d9ead3;
    }

    .investment-table tfoot td:last-child {
        text-align: right;
    }

    @media (max-width: 768px) { /* Adjust breakpoint as needed */
    .hide-on-mobile {
        display: none !important;
        color: red !important;
        height: 0 !important;
        padding: 0 !important;
        border: none !important;
    }
}

    /* Make the table responsive web-header */
    @media (max-width: 768px) {
        td.total-amount {
            display:none;

            color: red !important;
        }
        .investment-table thead tr:nth-child(2) {
            display: none;
        }
        .investment-table thead th, .investment-table thead td, .investment-table thead tr, .investment-table tbody th, .investment-table tbody td, .investment-table tbody tr {
            display: block;
            width: 100%;
        }

        .investment-table tfoot tr, .investment-table tfoot td {
            display: block !important;
            width: 100% !important;
        }

        .investment-table tr {
            margin-bottom: 10px;
            border-bottom: 1px solid #d4d4d4;
        }

        .investment-table th, .investment-table td {
            padding: 10px 5px;
            text-align: left;
        }

        .investment-table th {
            text-align: left;
            font-weight: bold;
        }

        .investment-table tbody td {
            display: flex;
            justify-content: space-between;
            padding-left: 50%;
            position: relative;
        }

        .investment-table tfoot td {
            display: flex;
            justify-content: space-between;
            padding-left: 50%;
            position: relative;
        }

        .investment-table td::before {
            content: attr(data-label);
            position: absolute;
            left: 10px;
            font-weight: bold;
            white-space: nowrap;
        }

        .investment-table td:last-child::before {
            text-align: left;
        }
    }
</style>